import * as React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography
} from '@mui/material';
import instance from '../../../axios/instance';
import { t } from "i18next";
import JobCard from './JobCard';
import NotFound from '../../reusableUi/Not Found';

function JobsData() {
  const [jobs, setAllJobs] = React.useState([]);

  React.useEffect(() => {
    (async () => {
      const response = await instance.get("job/accept-job");
      const data = response.data.data || [];
      setAllJobs([...data]);
    })();
  }, []);

  return (
    <Container sx={{ marginTop: "8rem", marginBottom: "4rem" }}>
      <Box sx={{ width: '100%', textAlign: 'center', marginBottom: 4 }}>
        {/* title */}
        <Typography
          variant="h4"
          sx={{ color: '#3B82F6FC', fontWeight: 'bold', mb: 2 }}
        >
          {t("Your career opportunity starts here!")}
        </Typography>

        {/* description */}
        <Typography
          variant="body1"
          sx={{ fontWeight: 300, color: '#000', mb: 4 }}
        >
          {t("Are you looking for a new job opportunity? The Moalime platform offers you a variety of opportunities in various fields. Additionally, you can now apply for available jobs through the advertisements displayed on our platform. Don't miss this opportunity and start building your professional future with Moalime today.")}
        </Typography>
      </Box>

      {
        !jobs.length ? (
          <NotFound text={t("Unfortunately, there are currently no jobs available.")} />
        ) : (
          <Grid container spacing={3}>
            {jobs.map((job, idx) => (
              <Grid item key={idx} xs={12} sm={6} md={4}>
                <JobCard Jobs={job} />
              </Grid>
            ))}
          </Grid>
        )
      }
    </Container>
  );
}

export default JobsData;
